import { render, staticRenderFns } from "./CustomEditComp.vue?vue&type=template&id=4a316d66&scoped=true&"
import script from "./CustomEditComp.vue?vue&type=script&lang=ts&"
export * from "./CustomEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./CustomEditComp.vue?vue&type=style&index=0&id=4a316d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a316d66",
  null
  
)

export default component.exports